<div class="wrapper">
  <div class="card-container">
    <app-login-card [forgotPasswordPath]="forgotPasswordPath"></app-login-card>
  </div>
</div>
